import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import {
    DetailLabel,
    ProfileIdFieldsSection,
    ProfileIdFieldRow,
    ProfileIdValueBox,
    ProfileIdValueText,
    ProfileIdCopyButton,
} from '@/pages/inside/tenant/style';

const ProfileCopyableIdField = ({ label, value, onCopy }) => (
    <ProfileIdFieldRow>
        <DetailLabel>{label}</DetailLabel>
        <ProfileIdValueBox>
            <Tooltip title={value}>
                <ProfileIdValueText>{value}</ProfileIdValueText>
            </Tooltip>
            <Tooltip title="Copy">
                <ProfileIdCopyButton
                    type="button"
                    aria-label={`Copy ${label}`}
                    onClick={() => onCopy(value, label)}
                >
                    <CopyOutlined />
                </ProfileIdCopyButton>
            </Tooltip>
        </ProfileIdValueBox>
    </ProfileIdFieldRow>
);

ProfileCopyableIdField.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onCopy: PropTypes.func.isRequired,
};

const ProfileCopyableIdsBlock = ({ companyId, publicId, onCopy }) => {
    if (!companyId && !publicId) return null;

    return (
        <ProfileIdFieldsSection>
            {companyId ? (
                <ProfileCopyableIdField label="Company ID" value={companyId} onCopy={onCopy} />
            ) : null}
            {publicId ? (
                <ProfileCopyableIdField label="Public ID" value={publicId} onCopy={onCopy} />
            ) : null}
        </ProfileIdFieldsSection>
    );
};

ProfileCopyableIdsBlock.propTypes = {
    companyId: PropTypes.string,
    publicId: PropTypes.string,
    onCopy: PropTypes.func.isRequired,
};

export default ProfileCopyableIdsBlock;
